module.exports = "./app-dist/templates/header-mobile-home.controller.a4ad00ffc2736e76a1e7508d14ee40cc.html";